import { render, staticRenderFns } from "./discount-info-card.vue?vue&type=template&id=8ed02c1c"
import script from "./discount-info-card.vue?vue&type=script&lang=js"
export * from "./discount-info-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports